/**
 * List of Forte Number
 * @see https://en.wikipedia.org/wiki/List_of_pitch-class_sets
 *
 */

var fortemap = new Map()

fortemap.set("[0,1,2]", "3-1");
fortemap.set("[0,1,3]", "3-2");
fortemap.set("[0,1,4]", "3-3");
fortemap.set("[0,1,5]", "3-4");
fortemap.set("[0,1,6]", "3-5");
fortemap.set("[0,2,4]", "3-6");
fortemap.set("[0,2,5]", "3-7");
fortemap.set("[0,2,6]", "3-8");
fortemap.set("[0,2,7]", "3-9");
fortemap.set("[0,3,6]", "3-10");
fortemap.set("[0,3,7]", "3-11");
fortemap.set("[0,4,8]", "3-12");
fortemap.set("[0,1,2,3]", "4-1");
fortemap.set("[0,1,2,4]", "4-2");
fortemap.set("[0,1,2,5]", "4-4");
fortemap.set("[0,1,2,6]", "4-5");
fortemap.set("[0,1,2,7]", "4-6");
fortemap.set("[0,1,3,4]", "4-3");
fortemap.set("[0,1,3,5]", "4-11");
fortemap.set("[0,1,3,6]", "4-13");
fortemap.set("[0,1,3,7]", "4-Z29");
fortemap.set("[0,1,4,5]", "4-7");
fortemap.set("[0,1,4,6]", "4-Z15");
fortemap.set("[0,1,4,7]", "4-18");
fortemap.set("[0,1,4,8]", "4-19");
fortemap.set("[0,1,5,6]", "4-8");
fortemap.set("[0,1,5,7]", "4-16");
fortemap.set("[0,1,5,8]", "4-20");
fortemap.set("[0,1,6,7]", "4-9");
fortemap.set("[0,2,3,5]", "4-10");
fortemap.set("[0,2,3,6]", "4-12");
fortemap.set("[0,2,3,7]", "4-14");
fortemap.set("[0,2,4,6]", "4-21");
fortemap.set("[0,2,4,7]", "4-22");
fortemap.set("[0,2,4,8]", "4-24");
fortemap.set("[0,2,5,7]", "4-23");
fortemap.set("[0,2,5,8]", "4-27");
fortemap.set("[0,2,6,8]", "4-25");
fortemap.set("[0,3,4,7]", "4-17");
fortemap.set("[0,3,5,8]", "4-26");
fortemap.set("[0,3,6,9]", "4-28");
fortemap.set("[0,1,2,3,4]", "5-1");
fortemap.set("[0,1,2,3,5]", "5-2");
fortemap.set("[0,1,2,3,6]", "5-4");
fortemap.set("[0,1,2,3,7]", "5-5");
fortemap.set("[0,1,2,4,5]", "5-3");
fortemap.set("[0,1,2,4,6]", "5-9");
fortemap.set("[0,1,2,4,7]", "5-Z36");
fortemap.set("[0,1,2,4,8]", "5-13");
fortemap.set("[0,1,2,5,6]", "5-6");
fortemap.set("[0,1,2,5,7]", "5-14");
fortemap.set("[0,1,2,5,8]", "5-Z38");
fortemap.set("[0,1,2,6,7]", "5-7");
fortemap.set("[0,1,2,6,8]", "5-15");
fortemap.set("[0,1,3,4,6]", "5-10");
fortemap.set("[0,1,3,4,7]", "5-16");
fortemap.set("[0,1,3,4,8]", "5-Z17");
fortemap.set("[0,1,3,5,6]", "5-Z12");
fortemap.set("[0,1,3,5,7]", "5-24");
fortemap.set("[0,1,3,5,8]", "5-27");
fortemap.set("[0,1,3,6,7]", "5-19");
fortemap.set("[0,1,3,6,8]", "5-29");
fortemap.set("[0,1,3,6,9]", "5-31");
fortemap.set("[0,1,4,5,7]", "5-Z18");
fortemap.set("[0,1,4,5,8]", "5-21");
fortemap.set("[0,1,4,6,8]", "5-30");
fortemap.set("[0,1,4,6,9]", "5-32");
fortemap.set("[0,1,4,7,8]", "5-22");
fortemap.set("[0,1,5,6,8]", "5-20");
fortemap.set("[0,2,3,4,6]", "5-8");
fortemap.set("[0,2,3,4,7]", "5-11");
fortemap.set("[0,2,3,5,7]", "5-23");
fortemap.set("[0,2,3,5,8]", "5-25");
fortemap.set("[0,2,3,6,8]", "5-28");
fortemap.set("[0,2,4,5,8]", "5-26");
fortemap.set("[0,2,4,6,8]", "5-33");
fortemap.set("[0,2,4,6,9]", "5-34");
fortemap.set("[0,2,4,7,9]", "5-35");
fortemap.set("[0,3,4,5,8]", "5-Z37");
fortemap.set("[0,1,2,3,4,5]", "6-1");
fortemap.set("[0,1,2,3,4,6]", "6-2");
fortemap.set("[0,1,2,3,4,7]", "6-Z36");
fortemap.set("[0,1,2,3,4,8]", "6-Z37");
fortemap.set("[0,1,2,3,5,7]", "6-9");
fortemap.set("[0,1,2,3,5,8]", "6-Z40");
fortemap.set("[0,1,2,3,6,7]", "6-5");
fortemap.set("[0,1,2,3,6,8]", "6-Z41");
fortemap.set("[0,1,2,3,6,9]", "6-Z42");
fortemap.set("[0,1,2,3,7,8]", "6-Z38");
fortemap.set("[0,1,2,4,5,8]", "6-15");
fortemap.set("[0,1,2,4,6,8]", "6-22");
fortemap.set("[0,1,2,4,6,9]", "6-Z46");
fortemap.set("[0,1,2,4,7,8]", "6-Z17");
fortemap.set("[0,1,2,4,7,9]", "6-Z47");
fortemap.set("[0,1,2,5,6,9]", "6-Z44");
fortemap.set("[0,1,2,5,7,8]", "6-18");
fortemap.set("[0,1,2,5,7,9]", "6-Z48");
fortemap.set("[0,1,2,6,7,8]", "6-7");
fortemap.set("[0,1,3,4,5,7]", "6-Z10");
fortemap.set("[0,1,3,4,5,8]", "6-14");
fortemap.set("[0,1,3,4,6,9]", "6-27");
fortemap.set("[0,1,3,4,7,9]", "6-Z49");
fortemap.set("[0,1,3,5,7,9]", "6-34");
fortemap.set("[0,1,4,5,7,9]", "6-31");
fortemap.set("[0,1,3,6,7,9]", "6-30");
fortemap.set("[0,2,3,6,7,9]", "6-Z29");
fortemap.set("[0,1,4,5,6,8]", "6-16");
fortemap.set("[0,1,4,5,8,9]", "6-20");
fortemap.set("[0,2,3,4,5,7]", "6-8");
fortemap.set("[0,2,3,4,6,8]", "6-21");
fortemap.set("[0,2,3,4,6,9]", "6-Z45");
fortemap.set("[0,2,3,5,7,9]", "6-33");
fortemap.set("[0,2,4,5,7,9]", "6-32");
fortemap.set("[0,2,4,6,8,10]", "6-35");
fortemap.set("[0,1,2,3,5,6]", "6-Z3");
fortemap.set("[0,1,2,4,5,6]", "6-Z4");
fortemap.set("[0,1,2,4,5,7]", "6-Z11");
fortemap.set("[0,1,2,4,6,7]", "6-Z12");
fortemap.set("[0,1,3,4,6,7]", "6-Z13");
fortemap.set("[0,1,2,5,6,7]", "6-Z6");
fortemap.set("[0,1,3,4,6,8]", "6-Z24");
fortemap.set("[0,1,2,5,6,8]", "6-Z43");
fortemap.set("[0,1,3,5,6,8]", "6-Z25");
fortemap.set("[0,1,3,4,7,8]", "6-Z19");
fortemap.set("[0,1,3,5,7,8]", "6-Z26");
fortemap.set("[0,2,3,4,5,8]", "6-Z39");
fortemap.set("[0,1,3,5,6,9]", "6-Z28");
fortemap.set("[0,1,4,6,7,9]", "6-Z50");
fortemap.set("[0,2,3,5,6,8]", "6-Z23");
fortemap.set("[0,1,2,3,4,5,6,7,8]", "9-1");
fortemap.set("[0,1,2,3,4,5,6,7,9]", "9-2");
fortemap.set("[0,1,2,3,4,5,6,8,9]", "9-3");
fortemap.set("[0,1,2,3,4,5,7,8,9]", "9-4");
fortemap.set("[0,1,2,3,4,6,7,8,9]", "9-5");
fortemap.set("[0,1,2,3,4,5,6,8,10]", "9-6");
fortemap.set("[0,1,2,3,4,5,7,8,10]", "9-7");
fortemap.set("[0,1,2,3,4,6,7,8,10]", "9-8");
fortemap.set("[0,1,2,3,5,6,7,8,10]", "9-9");
fortemap.set("[0,1,2,3,4,6,7,9,10]", "9-10");
fortemap.set("[0,1,2,3,5,6,7,9,10]", "9-11");
fortemap.set("[0,1,2,4,5,6,8,9,10]", "9-12");
fortemap.set("[0,1,2,3,4,5,6,7]", "8-1");
fortemap.set("[0,1,2,3,4,5,6,8]", "8-2");
fortemap.set("[0,1,2,3,4,5,7,8]", "8-4");
fortemap.set("[0,1,2,3,4,6,7,8]", "8-5");
fortemap.set("[0,1,2,3,5,6,7,8]", "8-6");
fortemap.set("[0,1,2,3,4,5,6,9]", "8-3");
fortemap.set("[0,1,2,3,4,5,7,9]", "8-11");
fortemap.set("[0,1,2,3,4,6,7,9]", "8-13");
fortemap.set("[0,1,2,3,5,6,7,9]", "8-Z29");
fortemap.set("[0,1,2,3,4,5,8,9]", "8-7");
fortemap.set("[0,1,2,3,4,6,8,9]", "8-Z15");
fortemap.set("[0,1,2,3,5,6,8,9]", "8-18");
fortemap.set("[0,1,2,4,5,6,8,9]", "8-19");
fortemap.set("[0,1,2,3,4,7,8,9]", "8-8");
fortemap.set("[0,1,2,3,5,7,8,9]", "8-16");
fortemap.set("[0,1,2,4,5,7,8,9]", "8-20");
fortemap.set("[0,1,2,3,6,7,8,9]", "8-9");
fortemap.set("[0,2,3,4,5,6,7,9]", "8-10");
fortemap.set("[0,1,3,4,5,6,7,9]", "8-12");
fortemap.set("[0,1,2,4,5,6,7,9]", "8-14");
fortemap.set("[0,1,2,3,4,6,8,10]", "8-21");
fortemap.set("[0,1,2,3,5,6,8,10]", "8-22");
fortemap.set("[0,1,2,4,5,6,8,10]", "8-24");
fortemap.set("[0,1,2,3,5,7,8,10]", "8-23");
fortemap.set("[0,1,2,4,5,7,8,10]", "8-27");
fortemap.set("[0,1,2,4,6,7,8,10]", "8-25");
fortemap.set("[0,1,3,4,5,6,8,9]", "8-17");
fortemap.set("[0,1,3,4,5,7,8,10]", "8-26");
fortemap.set("[0,1,3,4,6,7,9,10]", "8-28");
fortemap.set("[0,1,2,3,4,5,6]", "7-1");
fortemap.set("[0,1,2,3,4,5,7]", "7-2");
fortemap.set("[0,1,2,3,4,6,7]", "7-4");
fortemap.set("[0,1,2,3,5,6,7]", "7-5");
fortemap.set("[0,1,2,3,4,5,8]", "7-3");
fortemap.set("[0,1,2,3,4,6,8]", "7-9");
fortemap.set("[0,1,2,3,5,6,8]", "7-Z36");
fortemap.set("[0,1,2,4,5,6,8]", "7-13");
fortemap.set("[0,1,2,3,4,7,8]", "7-6");
fortemap.set("[0,1,2,3,5,7,8]", "7-14");
fortemap.set("[0,1,2,4,5,7,8]", "7-Z38");
fortemap.set("[0,1,2,3,6,7,8]", "7-7");
fortemap.set("[0,1,2,4,6,7,8]", "7-15");
fortemap.set("[0,1,2,3,4,6,9]", "7-10");
fortemap.set("[0,1,2,3,5,6,9]", "7-16");
fortemap.set("[0,1,2,4,5,6,9]", "7-Z17");
fortemap.set("[0,1,2,3,4,7,9]", "7-Z12");
fortemap.set("[0,1,2,3,5,7,9]", "7-24");
fortemap.set("[0,1,2,4,5,7,9]", "7-27");
fortemap.set("[0,1,2,3,6,7,9]", "7-19");
fortemap.set("[0,1,2,4,6,7,9]", "7-29");
fortemap.set("[0,1,3,4,6,7,9]", "7-31");
fortemap.set("[0,1,2,3,6,7,10]", "7-Z18");
fortemap.set("[0,1,2,4,5,8,9]", "7-21");
fortemap.set("[0,1,2,4,6,8,9]", "7-30");
fortemap.set("[0,1,3,4,6,8,9]", "7-32");
fortemap.set("[0,1,3,4,7,8,9]", "7-22");
fortemap.set("[0,1,2,5,6,7,9]", "7-20");
fortemap.set("[0,2,3,4,5,6,8]", "7-8");
fortemap.set("[0,1,3,4,5,6,8]", "7-11");
fortemap.set("[0,2,3,4,5,7,9]", "7-23");
fortemap.set("[0,2,3,4,6,7,9]", "7-25");
fortemap.set("[0,1,3,5,6,7,9]", "7-28");
fortemap.set("[0,1,3,4,5,7,9]", "7-26");
fortemap.set("[0,1,3,5,7,9,11]", "7-33");
fortemap.set("[0,1,3,5,7,9,10]", "7-34");
fortemap.set("[0,1,3,5,6,8,10]", "7-35");
fortemap.set("[0,1,3,4,5,7,8]", "7-Z37");

// for (var k of fortemap.keys()) {
//  console.log(k + ' => ' + fortemap.get(k));
// }

// console.log(JSON.stringify(fortemap));

function forte(pcs) {
  return fortemap.get(pcs)
}

export default function(pcs) {
	return fortemap.get(pcs)
}
